module.exports = __webpack_public_path__ + "img/silver4.7374a00d.png";